/* tslint:disable */
'use client'

import React, {useState, useEffect} from 'react'
import {useParams, useRouter} from '@/utils/navigation'

import store from "@/store";
//import {getCompanyId} from '@/utils/getCompanyId'
import {InitialProductData, ProductData} from '@/types/product'
import Heading from '@/components/Heading/Heading'
import initialProductData from "@/components/Products/initialProductData";
import Splash from "@/components/splash/Splash";

import Modal from "@/components/Modal/Modal";
import removeBundleItem from "@/services/ProductService/removeBundleItem";

import Button from "@/components/UiElements/Button";
import AddBundleItem from "@/components/Products/Components/AddBundleItem";
import ImageWithLoader from "@/components/UiElements/ImageWithLoader";
import ProductListItem from "@/app/products/ProductListItem";
import convertBundleToSingle from "@/components/Products/utils/convertBundleToSingle";
import Alert from "@/components/UiElements/Alert";
import ImageComponent from "@/components/UiElements/ImageComponent";
import updateProductInLocal from "@/services/ProductService/updateProductInLocal";



export default function Product() {
    const {sku} = useParams()
    const router = useRouter()
    //const companyId = getCompanyId()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<InitialProductData | null>(null)
    const [createProductIsOpen, setCreateProductIsOpen] = useState(false)


    const handleAddBundleItem = () => {
        setCreateProductIsOpen(false)
    }


    const initialData = async () => {
        setLoading(true)
        initialProductData(sku).then((data) => {

            // Protect if product has profile
            if (data?.product?.product_profile_id) {
                router.push(`/products/sku/${data?.product["sku"]}`)
                return;
            }

            store.status.selectedProductInProductPage = data?.product?.sku || null
            if (data?.product ) updateProductInLocal(data.product)
            setData(data)
            setLoading(false)
            setCreateProductIsOpen(false)
        }).catch(() => {
            setData(null)
            setLoading(false)
            setCreateProductIsOpen(false)
        })
    }

    useEffect(() => {
        if (!data) initialData()
        return () => {
            store.status.selectedProductInProductPage = null
        }
    }, []);

    const handleUpdatePageData = () => {
        initialData()
    }

    const handleDeleteBundleItem = (item:ProductData) => {
        Alert.showAlert({
            title: "Remove Bundle Item",
            message: (
                <div className={"flex flex-col items-center justify-center "}>
                    <div className={"border border-gray-300 p-sm rounded-md my-md"}>
                        <ImageComponent
                            src={item?.["2d_image_url"]}
                            className={"!w-[100px] !h-[100px]"}
                        />
                    </div>
                    This will remove the item (SKU: {item.sku}) from this bundle. The product will remain in your catalog to reuse.
                </div>
            ),

            isCancelable: true,
            button: "Confirm & Remove",
            danger: true,
            callBack: async (ok) => {
                if (ok) {
                    setLoading(true)
                    await removeBundleItem(item.product_id, data?.product?.bundle?.id)
                    initialData()
                    //setLoading(false)
                }
            },
        });
    }




    return (
        <div className="flex h-full w-full bg-white gap-[32px]">
            <div className="flex-grow w-full">
                <Heading
                    title={
                        <div className={"flex flex-row gap-md items-center justify-center"}>
                            {data?.product?.['name'] || '...'}
                            <span className="font-icon-light text-gray-300 select-none"></span>
                            <span className={'inline-flex gap-xs text-gray-300 !text-text-lg select-none'}>Bundle</span>
                        </div>
                    }
                    description={data?.product?.['variant_name']}
                    parent={{
                        title: 'Products',
                        url: `/products#${data?.product?.product_id}`,
                    }}
                    options={[
                        {
                            title: 'Convert to Single',
                            onClick: async () => {
                                if (data?.product) {
                                    store.loadingPage = "Converting to single, please wait...";
                                    const response = await convertBundleToSingle(data?.product);
                                    if (response) {
                                        router.push(`/products/sku/${data?.product?.["sku"]}`);
                                    }
                                    store.loadingPage = null;
                                }
                            },
                            icon: '',
                            disabled: !data?.product
                        },
                        {
                            title: 'Download Profile',
                            icon: '',
                            disabled: true

                        },
                    ]}
                >
                    {data?.product && (
                        <div className={'flex flex-row gap-xxl items-center'}>
                            <div>
                                <ImageWithLoader src={data?.product?.['2d_image_url']} alt={data?.product?.['name']} className="w-[100px] h-[100px] object-cover"/>

                            </div>
                            <div className="flex-col justify-start items-start gap-2 inline-flex">
                                <div className="text-neutral-600 text-sm font-normal flex flex-row">
                                    <span className={'text-gray-400 w-[60px]'}>Sku: </span>
                                    {data?.product?.['sku']}
                                </div>
                                <div className="text-neutral-600 text-sm font-normal capitalize flex flex-row">
                                    <span className={'text-gray-400 w-[60px]'}>Variant: </span>
                                    {data?.product?.['variant_name'] || <span className={'text-gray-400'}>-</span>}
                                </div>
                                <div className="text-neutral-600 text-sm font-normal flex flex-row">
                                    <span
                                        className={'text-gray-400 w-[60px]'}>Price: </span>${Number(data?.product?.['price']).toFixed(2)}
                                </div>
                            </div>
                        </div>
                    )}
                </Heading>

                <div className={'px-xxl gap-lg flex flex-row x-[100%] pb-[200px] relative'}>

                    <div className={'w-[37px]'}/>
                    <div className={`min-w-[calc(100%-61px)]`}>
                        {loading && <Splash/>}
                        <div className={`flex flex-col gap-xl relative ${loading ? '1hidden' : ''}`}>
                            <Modal
                                title={"Add Bundle Item"}
                                isOpen={createProductIsOpen}
                                onClose={handleAddBundleItem}
                                className={"pt-md"}
                                closeOnOutsideClick={false}
                                containerClassName={""}
                                windowClassName={"!justify-start"}
                            >
                                <AddBundleItem
                                    productId={data?.product?.product_id}
                                    callBack={handleAddBundleItem}
                                    onUpdate={handleUpdatePageData}
                                    bundleId={data?.product?.bundle?.id}
                                />
                            </Modal>
                            <div className={"flex flex-col gap-xl"} >
                                <div>
                                    <div>
                                        <div className={`flex flex-col`}>
                                            <div className=" text-gray-900 text-xl font-medium">Assigned Bundle Items</div>
                                            <div className=" text-gray-400 text-sm font-normal ">You can manage or update this product&apos;s bundle items below.</div>
                                        </div>
                                    </div>
                                </div>
                                {/*${item.product_profile_id !== "" ? "" : "bg-red-100 rounded-md !pl-[8px] w-[calc(100%+8px)] left-[-8px]"}*/}
                                <div className={"flex-col flex "}>
                                    {data?.bundleItems?.map((item, index) => (
                                       <ProductListItem
                                            product={item} key={index}
                                            className={
                                                `!px-0 !pr-[55px] `+
                                                `after:block !after:content-['No Profile'] after:h-max after:w-max after:absolute after:top-0 after:left-0 after:bg-white`
                                            }
                                            url={`/products/sku/${item.sku}?bundle=${data?.product?.sku}`}
                                            onDelete={()=> handleDeleteBundleItem(item)}
                                       />

                                    ))}
                                </div>
                            </div>
                            <div>
                                <Button
                                    size={"lg"}
                                    onClick={() => setCreateProductIsOpen(true)}

                                >
                                    Add Bundle Item
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}
